"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Breadcrumb = void 0;
const UiKitLite_1 = require("../UiKitLite");
const react_1 = __importDefault(require("react"));
const react_2 = require("@chakra-ui/react");
const Breadcrumb = () => {
    return (react_1.default.createElement(react_2.VStack, { spacing: UiKitLite_1.UiKitLite.consistency.buffer, align: 'flex-start' },
        react_1.default.createElement(UiKitLite_1.UiKitLite.Text.Breadcrumb, { items: [
                {
                    label: 'James Potter',
                    onClick: () => alert('Riddikulus!'),
                },
                {
                    label: 'Harry Potter',
                    onClick: () => alert('Obliviate!'),
                },
                {
                    label: 'Albus Potter',
                    onClick: () => alert('Alohomora!'),
                },
            ] }),
        react_1.default.createElement(UiKitLite_1.UiKitLite.Text.Breadcrumb, { items: [
                {
                    label: 'Configurations',
                    onClick: () => window.open('/configurations'),
                },
                {
                    label: 'Configuration 123',
                },
            ] }),
        react_1.default.createElement(UiKitLite_1.UiKitLite.Text.Breadcrumb, { items: [
                {
                    label: 'Home',
                },
                {
                    label: 'Configurations',
                    onClick: () => window.open('/configurations'),
                },
                {
                    label: 'Configuration 123',
                },
            ] }),
        react_1.default.createElement(UiKitLite_1.UiKitLite.Text.Breadcrumb, { items: [
                {
                    label: 'One',
                    onClick: () => alert('One Clicked!'),
                },
                {
                    label: 'Two',
                    onClick: () => alert('Two Clicked!'),
                },
                {
                    label: 'Three',
                    onClick: () => alert('Three Clicked!'),
                },
                {
                    label: 'Four',
                    onClick: () => alert('Four Clicked!'),
                },
            ] }),
        react_1.default.createElement(UiKitLite_1.UiKitLite.Text.Breadcrumb, { items: [
                {
                    label: 'One',
                    onClick: () => alert('One Clicked!'),
                },
                {
                    label: 'Two',
                    onClick: () => alert('Two Clicked!'),
                },
                {
                    label: 'Three',
                    onClick: () => alert('Three Clicked!'),
                },
                {
                    label: 'Four',
                },
            ] }),
        react_1.default.createElement(UiKitLite_1.UiKitLite.Text.Breadcrumb, { items: [
                {
                    label: 'One',
                    onClick: () => alert('One Clicked!'),
                },
                {
                    label: 'Two',
                },
                {
                    label: 'Three',
                    onClick: () => alert('Three Clicked!'),
                },
                {
                    label: 'Four',
                },
            ] })));
};
exports.Breadcrumb = Breadcrumb;
